define('commons/multiselect',['jquery'], function($) {
	$.fn.multiselect = function() {
		var self = this;
		var $f = $(this);
		
		var container = $('<div class="chosen-container chosen-container-multi" style="width: 175px;"></div>');
		var selected = $('<ul class="chosen-choices" style="padding: 8px; border-radius: 4px; cursor: default;" tabindex="0"></ul>').appendTo(container);
		var downArrow = $('<span class="fas fa-caret-down" style="font-size: 16px; margin-top: 2px; margin-right: 6px;"></span>');
		var summary = $('<li style="white-space: nowrap"></li>').appendTo(selected);
		var drop = $('<div class="chosen-drop"></div>').appendTo(container);
		var ul = $('<ul class="chosen-results"></ul>').appendTo(drop);
		var opened = false;
		
		var refreshSummary = function() {
			summary.empty();
			summary.append(downArrow);
			
			var texts = $f.find('option:selected').map(function() { return $(this).text(); }).get();
			
			$('<span></span>').text(texts.length == 0 ? 'All types' : texts).appendTo(summary);
		};
		
		var close;
		var open = function() {
			if (opened) {
				return;
			}
			opened = true;
			
			container.addClass('chosen-with-drop chosen-container-active');
			downArrow.removeClass('fa-caret-down');
			downArrow.addClass('fa-caret-up');
			
			var onKeyDown = function(e) {
				var selected = ul.find('li.highlighted');
				
				selected = $(selected.length > 0 ? selected[0] : ul.find('li')[0]);

				if (e.which == 27) {
					close();
				} else if (e.which == 40) {
					var next = selected.next('li');
					if (next.length > 0) {
						selected.removeClass('highlighted');
						next.find('input').focus();
					}
				} else if (e.which == 38) {
					var prev = selected.prev('li');
					if (prev.length > 0) {
						selected.removeClass('highlighted');
						prev.find('input').focus();
					}
				}
			};

			var mouseUp = function(e) {
				if (!container.is(e.target) && container.has(e.target).length === 0) {
					close();
				}
			};
			var focusIn = function(e) {
				if (!container.is(e.target) && container.has(e.target).length === 0 && $(e.target).has(container).length === 0) {
					close();
				}
			};
			
			close = function() {
				if (! opened) {
					return;
				}
				$(document).unbind('keydown', onKeyDown);
				$(document).unbind('mouseup', mouseUp);
				$(document).unbind('focusin', focusIn);
				opened = false;
				container.removeClass('chosen-with-drop chosen-container-active');
                downArrow.removeClass('fa-caret-up');
                downArrow.addClass('fa-caret-down');
			};
			
			$(document).keydown(onKeyDown);
			$(document).mouseup(mouseUp);
			$(document).focusin(focusIn);
		};

		selected.focus(open);
		selected.click(open);
		
		var createOption = function(text, option, selected) {
			var li = $('<li class="active-result"><input type="checkbox" /> ' + text + '</li>');
			var checkbox = li.find('input');
			
			if (selected) {
				checkbox.prop('checked', true);
			}
			
			checkbox.focus(function() { li.addClass('highlighted'); });
			checkbox.blur(function() { li.removeClass('highlighted'); });
			checkbox.click(function(e) { e.stopPropagation(); });
			li.click(function() {
				var checked = checkbox.prop('checked');
				var nbChecked = $f.find('option:selected').length;
				
				ul.find('li input').prop('checked', false).trigger('change');
				
				if (!checked || (nbChecked > 1 && option)) {
					checkbox.prop('checked', true).trigger('change');
				}
				
				close();
			});
			li.mouseenter(function() { li.addClass('highlighted'); });
			li.mouseleave(function() { li.removeClass('highlighted'); });
			
			var onChange = function() {
				if (option) {
					checkbox.prop('checked', option.selected);
					refreshSummary();
				}
			};
			$f.change(onChange);
			$f.on('multiselect:updated', onChange);
			
			checkbox.change(function(e) {
				if (option) {
					option.selected = checkbox.prop('checked') ? 'selected' : '';
					$f.trigger('change');
				} else {
					ul.find('li input').each(function() {
						if (this !== checkbox[0]) {
							$(this).prop('checked', checkbox.prop('checked')).trigger('change');
						}
					});
				}
				refreshSummary();
			});
			return li;
		};
		
		var reset = function() {
			ul.empty();
			var li = createOption('Select all').appendTo(ul);
			
			$f.find('option').each(function() {
				createOption($(this).text(), this, this.selected).appendTo(ul);
			});
	
			refreshSummary();
		};
		
		reset();
		
		$f.css('width', 0).css('height', 0).css('border', 0).css('margin', 0).css('padding', 0).css('overflow', 'hidden');
		$f.after(container);
		
		$f.on('multiselect:reset', reset);
		
		return this;
	};
});
